module.exports = __webpack_public_path__ + "static/urban12-26d57fb8ead2d76b80922addfc070ca6.jpg";